import VehicleHighlights from "./VehicleHighlights";

export default VehicleHighlights;
